<article class="client-case-page" #caseRoot>
  <section class="client-case-hero">
    <div class="container">
      <div class="client-case-hero-grid">
        <div class="client-case-copy">
          <a class="client-case-back reveal-on-scroll" data-reveal="button" data-reveal-trigger="immediate" routerLink="/clientes">
            <i class="bi bi-arrow-left"></i>
            Portafolio
          </a>
          <div class="section-head reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
            <p class="client-case-kicker">{{ caseStudy.category }}</p>
            <h1>{{ caseStudy.title }}</h1>
            <p class="client-case-description">{{ caseStudy.description }}</p>
          </div>
          <div class="client-case-tags reveal-on-scroll" data-reveal="card" data-reveal-trigger="immediate" style="--reveal-order: 1" aria-label="Etiquetas del proyecto">
            @for (tag of caseStudy.tags; track tag) {
            <span>{{ tag }}</span>
            }
          </div>
        </div>

        <figure class="client-case-visual reveal-on-scroll" data-reveal="media" data-reveal-trigger="immediate" style="--reveal-order: 2">
          <img class="img-fluid" [src]="caseStudy.image" [alt]="caseStudy.title" />
          <figcaption>
            <span>Case study</span>
            <strong>{{ caseStudy.title }}</strong>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>

  <section class="client-case-content">
    <div class="container">
      <div class="client-case-summary reveal-on-scroll" data-reveal="text">
        <p>{{ caseStudy.overview }}</p>
      </div>

      <div class="client-case-stat-grid">
        @for (stat of caseStudy.stats; track stat.label; let i = $index) {
        <article class="reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i % 3">
          <strong>{{ stat.value }}</strong>
          <span>{{ stat.label }}</span>
        </article>
        }
      </div>

      <div class="client-case-process">
        <article class="reveal-on-scroll" data-reveal="card" style="--reveal-order: 0">
          <span>01</span>
          <h2>Reto</h2>
          <p>{{ caseStudy.challenge }}</p>
        </article>
        <article class="reveal-on-scroll" data-reveal="card" style="--reveal-order: 1">
          <span>02</span>
          <h2>Solución</h2>
          <p>{{ caseStudy.solution }}</p>
        </article>
        <article class="reveal-on-scroll" data-reveal="card" style="--reveal-order: 2">
          <span>03</span>
          <h2>Resultado</h2>
          <p>{{ caseStudy.outcome }}</p>
        </article>
      </div>

      <aside class="client-case-cta reveal-on-scroll" data-reveal="card">
        <div>
          <p class="client-case-kicker">Siguiente proyecto</p>
          <h2>Convertimos poca información en una ruta clara de crecimiento.</h2>
        </div>
        <a class="dingo-cta-primary" routerLink="/contacto">
          Hablemos de tu caso
          <i class="bi bi-arrow-up-right"></i>
        </a>
      </aside>
    </div>
  </section>
</article>
